import {
  DocumentBeanComplexMetadata,
  NewsMetadata,
} from '../generated/papyrus-metadata/api';

export const parseNewsItem = (item: DocumentBeanComplexMetadata) => {
  const newsMetadata = item.complexMetadata as NewsMetadata;
  return {
    title: newsMetadata.title,
    content: newsMetadata.description,
    description: '',
  };
};
